Vendd.Scripts.load(function () {

    var $wrapper = $('.x-age-verification-popup');

    if ($wrapper.length < 1)
        return;

    InitAgeVerificationPopUp();

    function InitAgeVerificationPopUp() {

        var ageCookie = Cookies.get('aboveAge');

        var $container = $('.age-verification-popup', $wrapper);

        var redirectUrl = $container.data('redirect-url');
        var cookieDuration = $container.data('cookie-duration') || 30;
        var canClose = $container.data('can-close').toLowerCase() === 'true';

        if (!ageCookie || typeof ageCookie === "undefined") {
            $('.open-fancy-age', $wrapper).fancybox({
                margin: [20, 0],
                modal: !canClose,
                afterClose: function () {
                    Cookies.set("aboveAge", true, { expires: cookieDuration, samesite: 'Lax' });
                }
            });
            //open fancybox
            $('.open-fancy-age', $wrapper).trigger("click"); 

            //age verification
            $('.js-verification', $container).click(function () {
                $.fancybox.close(true);
            });

            //age prohibition
            $('.js-prohibition', $container).click(function () {
                if (redirectUrl.length > 0) {
                    window.location.href = redirectUrl;
                } else {
                    $('.fancy-age-container').addClass('no-verification');
                }
            });

            //back to age verification
            $('.js-back-to-verification', $container).click(function () {
                $('.fancy-age-container').removeClass('no-verification');
            });
        } 
    }
});
